import styled from '@emotion/styled';
import { Button } from '../Button/Button';

/**
 * One button for both providers. The Google flow starts from this button, so
 * Google styles nothing on the page.
 *
 * Neither the primary nor the secondary variant applies. Both providers require
 * a neutral surface, and Google forbids its mark on a colored one.
 */
const ProviderButton = styled(Button)`
  min-height: 3.5rem;
  border-color: ${({ theme }) => theme.colors.neutral.grey160};
  color: ${({ theme }) => theme.colors.neutral.black100};
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  background-image: none;

  &:hover,
  &:focus,
  &:active {
    border-color: ${({ theme }) => theme.colors.neutral.grey160};
    color: ${({ theme }) => theme.colors.neutral.black100};
    background-color: ${({ theme }) => theme.colors.neutral.grey40};
    background-image: none;
  }

  &:disabled {
    border-color: ${({ theme }) => theme.colors.neutral.grey80};
    color: ${({ theme }) => theme.colors.neutral.grey100};
    background-color: ${({ theme }) => theme.colors.neutral.white100};
  }
`;

export { ProviderButton };
